module.exports = __webpack_public_path__ + "media/assets/images/flags/ch-24106974ebe35d3e9f08cef291b32c19.svg";